import { useTranslation } from 'react-i18next';

import { SignUpFormProps } from './types';
import { CustomTelInput } from '../../../common/CustomTelInput/CustomInput';
import { CustomInput } from '../../../common/CustomInput/CustomInput';
import { TermsOfUsage } from '../TermsOfUsage/TermsOfUsage';
import { AuthButton } from '../../../common/Button/AuthButton/AuthButton';

export const SignUpForm: React.FC<SignUpFormProps> = ({
  formik,
  handleChangePhone,
  handleGoogleAuth,
  loadingAuthButton,
  stopLoadingButtonStatus,
}) => {
  const { t } = useTranslation();
  const { values, errors, touched, handleChange, setFieldTouched } = formik;

  return (
    <>
      <CustomTelInput
        fieldName={'phone'}
        label={t('userAuth.phonePlaceholder')}
        value={values.phone}
        onChange={(value) => {
          setFieldTouched('phone');
          handleChangePhone(value);
        }}
        error={touched['phone'] && errors.phone}
      />

      <CustomInput
        fieldName={'password'}
        autoComplete="current-password"
        label={t('userAuth.passwordPlaceholder')}
        isPassword={true}
        value={values.password}
        onChange={(e) => {
          setFieldTouched('password');
          handleChange(e);
        }}
        error={touched['password'] && errors.password}
      />

      <CustomInput
        fieldName={'repeatPassword'}
        autoComplete="current-password"
        label={t('userAuth.repeatPasswordPlaceholder')}
        isPassword={true}
        value={values.repeatPassword}
        onChange={(e) => {
          setFieldTouched('repeatPassword');
          handleChange(e);
        }}
        error={touched['repeatPassword'] && errors.repeatPassword}
      />

      <TermsOfUsage
        onChange={handleChange}
        value={values.checked}
        error={touched['checked'] && errors.checked}
        name="checked"
      />

      <AuthButton
        text={t('userAuth.signInViaGoogleBtnText')}
        onClick={handleGoogleAuth}
        loading={!stopLoadingButtonStatus && loadingAuthButton}
      />
    </>
  );
};
